// extracted by mini-css-extract-plugin
module.exports = {"link":"_1Ew1b","root":"_3fBAV","label":"_3zTRm"};